export class CompSearchRejectionReason {
  rejectionTypeId: number;
  rejectionSubTypeId: number;
  rejectionGroupTypeId: number;
  rejectionName: string;
  rejectionSubName: string;
  rejectionGroupName: string;
  primaryFunctionId: number;
}
